import { takeLatest, put, call } from 'redux-saga/effects';
import * as correspondentListAction from './action';
import { CORE_API, } from '../../config';
import { HTTP_HEADERS } from '../../constants';
import request from '../../components/Utils/httpHelper';
export function* getTaskListData(action) {
    let requestUrl = `${CORE_API}/correspondent/tasks/view/${action.data.status}/${action.data.pageNo}/${action.data.pageSize}`;
    try {
        const listResult = yield call(request, requestUrl, { method: 'GET', headers: HTTP_HEADERS });
        yield put(correspondentListAction.viewAllTasksSuccess(listResult.data))
    } catch (err) {
        yield put(correspondentListAction.viewAllTasksFailure(err))
    }
}
export function* getTaskList() {

    yield takeLatest(correspondentListAction.VIEW_ALL_TASKS, getTaskListData);
}

